import Vue from "vue";
import moment from "moment";

export default {
  name: "roll-transfer-detail",
  data: function () {
    return {
      role: "",
      branch: "",
      doc: null,
      acting: false,
    };
  },
  computed: {
    // ระดับผู้จัดการที่ทำใบโอนได้ (ตรงกับ backend RollTransferController)
    isManager() {
      return ["Branch Admin", "Branch Admin assistant", "Customer assistant manager"].includes(this.role);
    },
    // ปุ่มรับ: เฉพาะสาขาปลายทาง (หรือ Admin) + ใบยังรอรับ
    canReceive() {
      if (!this.doc || this.doc.status !== 1) return false;
      if (this.role === "Admin") return true;
      return this.isManager && Number(this.branch) === Number(this.doc.to_branch_id);
    },
    // ปุ่มยกเลิก: เฉพาะสาขาต้นทาง (หรือ Admin) + ใบยังรอรับ
    canCancel() {
      if (!this.doc || this.doc.status !== 1) return false;
      if (this.role === "Admin") return true;
      return this.isManager && Number(this.branch) === Number(this.doc.from_branch_id);
    },
  },
  async mounted() {
    await this.getRole();
    await this.loadDoc();
  },
  methods: {
    async getRole() {
      const res = await this.$store.dispatch("Auth/getRole", {}, { root: true });
      this.role = res.data.role;
      this.branch = res.data.branch_id;
    },
    formatDate(d) {
      return d ? moment(d).format("DD/MM/YYYY HH:mm") : "-";
    },
    formatLength(n) {
      if (n === null || n === undefined || n === "") return "-";
      return Number(n).toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatNumber(n) {
      if (n === null || n === undefined || n === "" || n === "null") return "-";
      const value = Number(n);
      if (Number.isNaN(value)) return n;
      return value.toLocaleString("th-TH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    rollRawValue(it, key) {
      const snapshotValue = it ? it[key] : null;
      if (snapshotValue !== null && snapshotValue !== undefined && snapshotValue !== "" && snapshotValue !== "null") {
        return snapshotValue;
      }
      return it && it.roll ? it.roll[key] : null;
    },
    hasRollValue(it, key) {
      const value = this.rollRawValue(it, key);
      return value !== null && value !== undefined && value !== "" && value !== "null";
    },
    rollValue(it, key) {
      const value = this.rollRawValue(it, key);
      return value !== null && value !== undefined && value !== "" && value !== "null" ? value : "-";
    },
    displayCode(it) {
      return this.rollValue(it, "code");
    },
    displayBranchCode(it) {
      return this.rollValue(it, "branch_code");
    },
    displayBrand(it) {
      const brand = this.rollRawValue(it, "brand");
      if (brand === "OT") return this.rollValue(it, "if_other_brand");
      return brand && brand !== "null" ? brand : "-";
    },
    displayNote(it) {
      const branchNote = this.rollRawValue(it, "branch_note");
      if (branchNote && branchNote !== "null") return branchNote;
      return this.rollValue(it, "note");
    },
    kgPerMeter(it) {
      const weight = Number(this.rollRawValue(it, "net_weight"));
      const length = Number(this.rollRawValue(it, "length"));
      if (!Number.isFinite(weight) || !Number.isFinite(length) || length <= 0) return "-";
      return (weight / length).toLocaleString("th-TH", { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    },
    statusText(s) {
      return { 1: "รอปลายทางรับ", 2: "รับแล้ว", 6: "ยกเลิก" }[s] || s;
    },
    statusVariant(s) {
      return { 1: "warning", 2: "success", 6: "secondary" }[s] || "light";
    },
    async loadDoc() {
      try {
        const res = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${this.$route.params.uuid}`
        );
        this.doc = res.data.data;
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "โหลดข้อมูลไม่สำเร็จ");
      }
    },
    async onReceive() {
      const confirm = await this.$swal({
        icon: "question",
        title: "ยืนยันรับม้วนเข้าสาขา?",
        text: `ม้วนทั้ง ${(this.doc.items || []).length} ม้วนจะเข้าสต็อกสาขาของคุณ`,
        showCancelButton: true,
        confirmButtonText: "รับม้วน",
        cancelButtonText: "ปิด",
      });
      if (!confirm.value) return;
      this.acting = true;
      try {
        await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${this.doc.uuid}/receive`
        );
        this.$swal({ icon: "success", title: "รับม้วนเข้าสาขาเรียบร้อย", confirmButtonText: "ตกลง" });
        await this.loadDoc();
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "รับม้วนไม่สำเร็จ");
      } finally {
        this.acting = false;
      }
    },
    async onCancel() {
      const confirm = await this.$swal({
        icon: "warning",
        title: "ยกเลิกใบโอนนี้?",
        text: "ม้วนทั้งหมดจะกลับเข้าสต็อกสาขาต้นทางตามเดิม",
        showCancelButton: true,
        confirmButtonText: "ยกเลิกใบโอน",
        cancelButtonText: "ปิด",
      });
      if (!confirm.value) return;
      this.acting = true;
      try {
        await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${this.doc.uuid}/cancel`
        );
        this.$swal({ icon: "success", title: "ยกเลิกใบโอนเรียบร้อย", confirmButtonText: "ตกลง" });
        await this.loadDoc();
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "ยกเลิกไม่สำเร็จ");
      } finally {
        this.acting = false;
      }
    },
    async generatePDF() {
      try {
        const result = await this.$axios.get(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${this.doc.uuid}/pdf`,
          { responseType: "blob" }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "targetWindow", "width=900,height=700");
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message);
      }
    },
  },
};
